import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex'
import {Toast} from 'vant'


Vue.use(Router)

const router=new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/page/index')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/page/index')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login')
    },
    {
      path: '/zhlogin',
      name: 'zhlogin',
      component: () => import('@/page/zhlogin')
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: () => import('@/page/orderlist')
    },
    {
      path: '/my',
      name: 'my',
      component: () => import('@/page/my')
    },
    {
      path: '/goodsinfo/:id',
      name: 'goodsinfo',
      component: () => import('@/page/goodsinfo')
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/page/order')
    },
    {
      path: '/addresslist/:from',
      name: 'addresslist',
      component: () => import('@/page/addresslist')
    },
    {
      path: '/addressedit',
      name: 'addressedit',
      component: () => import('@/page/addressedit')
    },
    {
      path: '/payment/:orderid',
      name: 'payment',
      component: () => import('@/page/payment')
    },
    {
      path: '/paymentyf/:realorderid',
      name: 'paymentyf',
      component: () => import('@/page/paymentyf')
    },
    {
      path: '/paymentpx/:orderid',
      name: 'paymentpx',
      component: () => import('@/page/paymentpx')
    },
    {
      path: '/article/:type',
      name: 'article',
      component: () => import('@/page/article')
    },
    {
      path: '/gongkai/:type',
      name: 'gongkai',
      component: () => import('@/page/gongkai')
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/page/setting')
    },
    {
      path: '/paymentresult',
      name: 'paymentresult',
      component: () => import('@/page/paymentresult')
    },
    {
      path: '/orderdetail/:orderid',
      name: 'orderdetail',
      component: () => import('@/page/orderdetail')
    },
    {
      path: '/goodslist',
      name: 'goodslist',
      component: () => import('@/page/goodslist')
    },
    {
      path: '/trainlist',
      name: 'trainlist',
      component: () => import('@/page/trainlist')
    },
    {
      path: '/dgoodslist',
      name: 'dgoodslist',
      component: () => import('@/page/dgoodslist')
    },
    {
      path: '/points',
      name: 'points',
      component: () => import('@/page/points')
    },
    {
      path: '/certification',
      name: 'certification',
      component: () => import('@/page/certification')
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('@/page/rules')
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('@/page/aboutus')
    },
    {
      path: '/mymanager',
      name: 'mymanager',
      component: () => import('@/page/mymanager')
    },
    {
      path: '/myclient',
      name: 'myclient',
      component: () => import('@/page/myclient')
    },
    {
      path: '/myprofile',
      name: 'myprofile',
      component: () => import('@/page/myprofile')
    },
    {
      path: '/security',
      name: 'security',
      component: () => import('@/page/security')
    },
    {
      path: '/delaccount',
      name: 'delaccount',
      component: () => import('@/page/delaccount')
    },
    {
      path: '/alterloginpsw',
      name: 'alterloginpsw',
      component: () => import('@/page/alterloginpsw')
    },
    {
      path: '/altermobile',
      name: 'altermobile',
      component: () => import('@/page/altermobile')
    },
    {
      path: '/bindcard',
      name: 'bindcard',
      component: () => import('@/page/bindcard')
    },
    {
      path: '/bindalipay',
      name: 'bindalipay',
      component: () => import('@/page/bindalipay')
    },
    {
      path: '/reg',
      name: 'reg',
      component: () => import('@/page/reg')
    },
    {
      path: '/fahuo',
      name: 'fahuo',
      component: () => import('@/page/fahuo')
    },
    {
      path: '/fhorder',
      name: 'fhorder',
      component: () => import('@/page/fhorder')
    },
    {
      path: '/dorder',
      name: 'dorder',
      component: () => import('@/page/dorder')
    },
    {
      path: '/surefahuo/:orderid',
      name: 'surefahuo',
      component: () => import('@/page/surefahuo')
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import('@/page/withdraw')
    },
    {
      path: '/alterlevel/:level',
      name: 'alterlevel',
      component: () => import('@/page/alterlevel')
    },
    {
      path: '/goodsdetail/:goodsid',
      name: 'goodsdetail',
      component: () => import('@/page/goodsdetail')
    },
    {
      path: '/dgoodsdetail/:goodsid',
      name: 'dgoodsdetail',
      component: () => import('@/page/dgoodsdetail')
    },
    {
      path: '/sporder',
      name: 'sporder',
      component: () => import('@/page/sporder')
    },
    {
      path: '/pointsdetail/:type/:ptype',
      name: 'pointsdetail',
      component: () => import('@/page/pointsdetail')
    },
    {
      path: '/sqbm',
      name: 'sqbm',
      component: () => import('@/page/sqbm')
    },
    {
      path: '/traindetail/:trainid',
      name: 'traindetail',
      component: () => import('@/page/traindetail')
    }
    ,
    {
      path: '/trainsure',
      name: 'trainsure',
      component: () => import('@/page/trainsure')
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/page/intro')
    },
    {
      path: '/sporder2',
      name: 'sporder2',
      component: () => import('@/page/sporder2')
    },
    {
      path: '/jglbuy',
      name: 'jglbuy',
      component: () => import('@/page/jglbuy')
    },
    {
      path: '/sporder2bm',
      name: 'sporder2bm',
      component: () => import('@/page/sporder2bm')
    },
    {
      path: '/sporder2bm_end',
      name: 'sporder2bm_end',
      component: () => import('@/page/sporder2bm_end')
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/page/test')
    },
    {
      path: '/mltb_upload',
      name: 'mltb_upload',
      component: () => import('@/page/mltb_upload')
    },
    {
      path: '/couponlist',
      name: 'couponlist',
      component: () => import('@/page/couponlist')
    },
    {
      path: '/qgpage',
      name: 'qgpage',
      component: () => import('@/page/qgpage')
    },
    {
      path: '/couponorder',
      name: 'couponorder',
      component: () => import('@/page/couponorder')
    },
    {
      path: '/zzupload',
      name: 'zzupload',
      component: () => import('@/page/zzupload')
    }
  ]
})

router.beforeEach((to, from,next) => {
    if(store.state.user.token=="" && to.name !== 'login' && to.name!=='zhlogin' && to.name!=='reg' && to.name!=='paymentresult' && to.name!=='gongkai'){
      Toast("登陆已超时，请重新登陆")
      store.commit("HIDE_LOADING")
      next({ name: 'login' })
    }else{
      next()
    }
})
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

export function goTo(url){
    router.push(url).catch(()=>{}) 
}

export default router

